import React from 'react';

export type ButtonVariant = 'primary' | 'secondary' | 'ghost';

export type ButtonProps<C extends React.ElementType = 'button'> = {
  variant?: ButtonVariant;
  as?: C;
  className?: string;
  children?: React.ReactNode;
} & Omit<React.ComponentPropsWithoutRef<C>, 'as' | 'className' | 'children'>;

const Button = <C extends React.ElementType = 'button'>(props: ButtonProps<C>) => {
  const {
    variant = 'primary',
    as,
    className = '',
    children,
    ...rest
  } = props;

  const Component = (as ?? 'button') as React.ElementType;

  const variants: Record<ButtonVariant, string> = {
    primary: 'btn-primary',
    secondary: 'btn-secondary',
    ghost: 'btn-ghost',
  };

  return (
    <Component className={`btn ${variants[variant]} ${className}`} {...rest}>
      {children}
    </Component>
  );
};

export default Button;
